export default __webpack_public_path__ + "static/media/Banner.cc8df473.png";